// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"87":"a8902fea","666":"775acda8"}[chunkId] + ".js";
};